/**
 * StagingBanner.js — top-of-page banner shown only when
 * REACT_APP_ENV=staging is baked into the build (sub-phase 3 of staging arc).
 *
 * Render gate: IS_STAGING === false -> render nothing.
 *
 * IS_STAGING is set at build time from process.env.REACT_APP_ENV via the
 * Dockerfile ARG. PROD builds don't set it, so the banner never renders.
 *
 * Position is in-flow (no `position: fixed`). The layouts compensate by
 * offsetting their fixed-position elements top: 0 -> top: LAYOUT_TOP_OFFSET
 * and reducing their 100vh heights by the same amount. LAYOUT_TOP_OFFSET
 * is the single source of truth in ../config.js.
 *
 * See docs/archive/handovers/2026-06-06_staging_environment_phase0_design.md and
 * docs/handovers/2026-06-06_staging_subphase3_phase0_design.md for context.
 */

import React from 'react';
import { IS_STAGING, STAGING_BANNER_PX } from '../config';

function StagingBanner() {
  if (!IS_STAGING) return null;

  return (
    <div
      style={{
        height: STAGING_BANNER_PX,
        background: '#F97316',
        color: '#FFFFFF',
        textAlign: 'center',
        lineHeight: `${STAGING_BANNER_PX}px`,
        fontSize: '0.875rem',
        fontWeight: 600,
        letterSpacing: '0.04em',
        boxShadow: '0 2px 4px rgba(0, 0, 0, 0.1)',
      }}
    >
      STAGING: TEST DATA
    </div>
  );
}

export default StagingBanner;
